import { InputHTMLAttributes, useEffect, useState } from 'react'

import * as S from './styles'

type CheckboxValue = string | ReadonlyArray<string> | number

export type CheckboxProps = {
  wrapperClassName?: string
  onCheck?: (status: boolean) => void
  isChecked?: boolean
  label?: string
  labelFor?: string
  labelColor?: 'white' | 'black' | '#4f4f4f'
  value?: CheckboxValue
} & InputHTMLAttributes<HTMLInputElement>

const Checkbox = ({
  wrapperClassName,
  isChecked = false,
  onCheck,
  label,
  labelFor = '',
  labelColor = 'black',
  value,
  ...props
}: CheckboxProps) => {
  // controlled component (state)
  const [checked, setChecked] = useState(isChecked)

  const onChange = () => {
    const status = !checked

    setChecked(status)

    if (onCheck) {
      onCheck(status)
    }
  }

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  return (
    <S.Wrapper className={wrapperClassName}>
      <S.Input
        onChange={onChange}
        type="checkbox"
        id={labelFor}
        checked={checked}
        value={value}
        {...props}
      />
      {!!label && (
        <S.Label labelColor={labelColor} htmlFor={labelFor}>
          {label}
        </S.Label>
      )}
    </S.Wrapper>
  )
}

export default Checkbox
